// Vuex 是一个专为 Vue.js 应用程序开发的状态管理模式
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import createLogger from 'vuex/dist/logger'
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
// “store”基本上就是一个容器，它包含着你的应用中大部分的状态 (state)。
const state = {
  message: null
}
export default new Vuex.Store({
  state,
  actions,
  mutations,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js